export const NAME = 'Name'
export const TEACHES_LESSONS = 'Lesson Instructor'
export const EXPERIENCE = 'Experience'
export const ELEMENTARY_COMPLETION = 'Elementary Completion'
export const MIDDLE_SCHOOL_COMPLETION = 'Middle School Completion'
export const ELEMENTARY_TRAINING = 'Elementary Training'
export const MIDDLE_SCHOOL_TRAINING = 'Middle School Training'
export const HIGH_SCHOOL_TRAINING = 'High School Training'
export const TOTAL_ELEM_TRAININGS = 3
export const TOTAL_MS_TRAININGS = 4
/** Required completions per DWB table column (elem / ms / hs each use this total). */
export const TOTAL_DWB_TRAININGS = 1

/** Shown when the site does not license that DWB program (site pref false). */
export const DWB_PROGRAM_DISABLED_MARK = '\u2014'

export const VARIANT_K8_CORE = 'k8-core'
export const VARIANT_K12_DWB = 'k12-dwb'

/** AutoTable colgroup widths for K–12 Digital Well-Being report (must sum to 100%). */
export const DWB_COLUMN_WIDTHS = ['40%', '20%', '20%', '20%']
